'use client';

import React from 'react';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import ReactHtmlParser from '@libs/reactHtmlParser';
import ParallaxText from '@components/ParallaxText';
import cn from './style.module.scss';

export default function AlGhadeerFooter(props: MarketingPageComponentProps) {
  const footerSection = props?.locale?.section?.find(
    (section: any) => section.type === 'footer' && section.enabled
  );
  if (!footerSection) return null;
  return (
    <Stack component="footer" className={cn.alGhadeerFooterWrapper}>
      <Box className={cn.alGhadeerFooterInner}>
        <Box className={cn.alGhadeerFooterStory}>
          <Box className={cn.alGhadeerFooterElement}>
            <p>{ReactHtmlParser(footerSection?.alghadeerFooterDeveloped)}</p>
          </Box>
          <Box className={cn.alGhadeerFooterElement}>
            <p>{ReactHtmlParser(footerSection?.alghadeerFooterGhadeer)}</p>
          </Box>
          <Box className={cn.alGhadeerFooterElement}>
            <ParallaxText
              variant="a"
              href="https://www.aldar.com/properties/en"
              target="_blank"
              rel="noopener noreferrer"
              animationType="zoomIn"
              animationDuration={500}
            >
              {ReactHtmlParser(footerSection?.alghadeerFooterALDAR)}
            </ParallaxText>
          </Box>
        </Box>
      </Box>
    </Stack>
  );
}
